module.exports = __webpack_public_path__ + "img/bcworks-logo.309d2dae.svg";